import { render, staticRenderFns } from "./ProductMoveModal.vue?vue&type=template&id=22cb2e47&scoped=true"
import script from "./ProductMoveModal.vue?vue&type=script&lang=js"
export * from "./ProductMoveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb2e47",
  null
  
)

export default component.exports